<template>
  <div class="ss__portrait" :style="style">
    <component
      class="ss__portrait__link"
      :is="data.deleted ? 'div' : link ? 'a' : 'div'"
      v-popover:userCard
      :href="link"
      :target="target">
      <img
        :src="portraitSrc"
        :key="data.avatar"
        :alt="data.nickname"
      />
      <SsUserIdentifier
        class="ss__portrait__badge"
        v-if="showBadge && data.user_badges && data.user_badges.length > 0"
        :identifier="data.user_badges[0]"
        :popoverDisable="badgePopoverDisalbed"
      />
    </component>

    <template v-if="!data.deleted && showUserCard">
      <ElPopover
        ref="userCard"
        trigger="hover"
        placement="right"
        :visible-arrow="false"
        popper-class="comp__SsUserCard__popover"
        :open-delay="500"
        @show="onUserCardShow">
        <SsUserCard
          :user="asyncUserData"
          :isSelf="isSelf"
          :isLogin="isLogin"
          :terminalType="terminalType"
          :identifierKey="identifierKey"
        />
      </ElPopover>
    </template>
  </div>
</template>

<script>
import { Popover as ElPopover } from 'element-ui'
import SsUserIdentifier from '../SsUserIdentifier'
import SsUserCard from '../SsUserCard'

export default {
  name: 'SsPortrait',
  components: {
    ElPopover,
    SsUserIdentifier,
    SsUserCard
  },
  props: {
    // 头像大小
    size: {
      type: Number,
      default: 24
    },
    proportion: {
      type: Number,
      default: 1.5
    },
    // 头像数据
    data: {
      type: Object,
      required: true
    },
    // 跳转地址
    link: {
      type: String,
      default: ''
    },
    showBadge: {
      type: Boolean,
      default: true
    },
    badgePopoverDisalbed: {
      type: Boolean,
      default: true
    },
    // 链接属性
    target: {
      type: String,
      default: '_self'
    },
    showUserCard: {
      type: Boolean,
      default: false
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    terminalType: {
      type: String
    },
    async: {
      type: Boolean,
      default: false
    },
    identifierKey: {
      type: String,
      default: 'user_flags'
    }
  },

  data () {
    return {
      asyncUserData: null,
      handled: false
    }
  },

  computed: {
    portraitSrc () {
      if (this.data.avatar) {
        const size = this.size || 24
        const proportion = this.proportion || 1.5
        return this.$formatImageSrc(this.data.avatar, { w: size * proportion * 2, h: size * proportion * 2 })
      }
      return this.$app.avatarSrc
    },
    style () {
      let style = {}
      if (this.size) {
        style['--size'] = `${this.size}px`
      }
      if (this.proportion) {
        style['--proportion'] = this.proportion
      }
      return style
    }
  },

  watch: {
    data: {
      immediate: true,
      handler: function () {
        this.asyncUserData = this.data
      }
    }
  },

  methods: {
    async onUserCardShow () {
      if (!this.data || !this.data.slug) return
      if (!this.async) return
      if (this.handled) return
      try {
        const res = await this.$http({
          url: '/user/slug/info/get',
          params: { slug: this.data.slug }
        })
        if (!res) throw new Error('请求失败或超时！')
        if (res.error) throw new Error(res.msg)
        this.asyncUserData = Object.assign({}, this.data, res.data)
        this.handled = true
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .ss__portrait {
    --size 24px
    --proportion 1.5
    display inline-block
    vertical-align middle
    height auto
    line-height normal
    position relative
    width var(--size)
    height var(--size)
    .ss__portrait__link {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    img {
      width 100%
      height 100%
      border-radius 50%
      background: #fff;
      background-clip: content-box;
      border: var(--border-SsAvatar, (1px solid var(--color-imageBorder)));
      box-sizing: border-box;
    }
    .ss__portrait__badge {
      position absolute
      width 40%
      height 40%
      right 0
      bottom 0
      --size-SsUserIdentifierIcon: 100%
    }
  }

  @media (min-width 768px)  {
    .ss__portrait {
      width calc(var(--size) * var(--proportion))
      height calc(var(--size) * var(--proportion))
    }
  }
</style>
<style lang="stylus">
.el-popover.comp__SsUserCard__popover,
.theme-dark .el-popover.comp__SsUserCard__popover {
  border: none;
  padding: 0px;
  background: transparent;
  overflow: visible;
  box-shadow: none;
}
</style>
